/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Slobodan Djordjevic
 */
import React from "react"
import {
    Button,
    CloseButton,
    Column,
    ContentSection,
    FooterSection,
    Label,
    Loading,
    Modal,
    Row,
    Step,
    StepController,
} from "trux"
import { Icon } from "trux/dist/atoms"
import { TRCToggle } from "../../trace"
import { TagEditor } from "../SaveToProfile/SaveClip"
import PreviewVideo from "../SaveToProfile/PreviewVideo"
import EditSpotlight from "../SaveToProfile/EditSpotlight"
import successImage from "../SaveToProfile/assets/success.gif"

export const PersonalizeMoment = (props) => {
    return (
        <Modal
            trkContext="Add to Trace IDv1"
            open={true}
            widthMD="60%"
            widthLG="50%"
            heightMD="80%"
            heightLG="80%"
            onShadeClick={props.onClose}
        >
            <StepController step={props.step}>
                <Step name="preview">
                    <ContentSection>
                        <CloseButton onClick={props.onClose} />
                        <Label
                            type={Label.Type.Heading3}
                            spacing="4"
                            content={
                                <>
                                    Save this Moment
                                    <br />
                                    to your Trace iD
                                </>
                            }
                            center
                        />
                        <PreviewVideo
                            clip={props.clip}
                            teamName={props.teamName}
                            gameId={props.gameId}
                        />
                    </ContentSection>
                    <FooterSection>
                        <Button
                            primary
                            trkAction="Preview Create Pressed"
                            trkPage="true"
                            onClick={(e) => {
                                e.preventDefault()
                                props.setStep("spotlight")
                            }}
                            content="Add Moment"
                        />
                    </FooterSection>
                </Step>

                <Step name="spotlight">
                    <ContentSection>
                        <CloseButton onClick={props.onClose} />
                        <Label
                            type={Label.Type.Heading3}
                            spacing="4 0 2 0"
                            content="Spotlight yourself"
                            center
                        />
                        <Row center marginBottom="2">
                            <TRCToggle
                                checked={props.checked}
                                onToggle={(e) => props.onToggle(e)}
                            />
                        </Row>
                        <EditSpotlight
                            disabled={props.disabled}
                            clip={props.clip}
                            spotlight={props.spotlight}
                            teamName={props.teamName}
                            gameId={props.gameId}
                            onSpotlightChange={props.onSpotlightChange}
                        />
                    </ContentSection>
                    <FooterSection>
                        <Button
                            trkAction="Continue Pressed"
                            onClick={props.showStepTwo}
                            primary
                            content="Continue to add tags"
                        />
                    </FooterSection>
                </Step>

                <Step name="tags">
                    <ContentSection>
                        <CloseButton onClick={props.onClose} />
                        <Label
                            type={Label.Type.Heading3}
                            spacing="4"
                            content="Tag your Moment"
                            center
                        />
                        <TagEditor
                            allTags={props.allTags}
                            tags={props.tags}
                            category={props.category}
                            setCategory={props.setCategory}
                            onSend={props.onSend}
                            toggleTag={props.toggleTag}
                        />
                    </ContentSection>
                    <FooterSection>
                        <Row center>
                            <Button
                                marginRight="2"
                                trkAction="Back Pressed"
                                trkPage="true"
                                onClick={(e) => props.setStep("spotlight")}
                                icon={Icon.Type.CheveronLeft}
                            />
                            <Button
                                primary
                                trkAction="Add Pressed"
                                trkPage="true"
                                onClick={props.onSend}
                                content="Add to my Trace iD"
                            />
                        </Row>
                    </FooterSection>
                </Step>

                <Step name="sending">
                    <ContentSection>
                        <Label
                            type={Label.Type.Heading3}
                            marginTop="8"
                            spacing="4"
                            center
                            content="Adding Moment &hellip;"
                        />
                        <Row center>
                            <Loading />
                        </Row>
                    </ContentSection>
                </Step>

                <Step name="success">
                    <ContentSection>
                        <CloseButton onClick={props.onClose} />
                        <Label
                            type={Label.Type.Heading3}
                            spacing="4"
                            content="Moment added!"
                            center
                        />
                        <Label center paddingBottom="4">
                            Your Moment has been added to your Trace iD by this
                            little guy.
                        </Label>
                        <img
                            className="icon-spot-success"
                            src={successImage}
                            alt="ok"
                        />
                    </ContentSection>
                    <FooterSection>
                        <Button
                            trkAction="Back to Games"
                            onClick={props.onClose}
                            content="Go back to my game"
                        />
                        <Button
                            trkAction="Open TraceID"
                            href={props.idLink}
                            content="See it on my Trace iD"
                            primary
                        />
                    </FooterSection>
                </Step>

                <Step name="failure">
                    <ContentSection>
                        <CloseButton onClick={props.onClose} />
                        <Column center span="12">
                            <Label
                                type={Label.Type.Heading3}
                                spacing="4"
                                content="Moment couldn't be added."
                                center
                            />
                            <Label center paddingBottom="4">
                                Sorry, TRACE-BOT messed up and couldn&apos;t add
                                your Moment. Are you connected to the internet?
                                Try adding it again.
                            </Label>
                            <Row center>
                                <img
                                    className="icon-spot-failure"
                                    alt="failure"
                                />
                            </Row>
                        </Column>
                    </ContentSection>
                    <FooterSection>
                        <Button
                            trkAction="Failure"
                            onClick={props.onClose}
                            content="OK"
                            primary
                        />
                    </FooterSection>
                </Step>
            </StepController>
        </Modal>
    )
}
